module.exports = __webpack_public_path__ + "img/wallet_02_qris_2.caec6a0a.png";